export default class MGSDKBridge {
  runTask(func) {
    func(window.MgtvApi);
  }
}
